import { controls,grouped } from "../controls";
const branches = {
label: "Branches",
pageLabel: "Branches",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
bulk:{columns:["bank_id","branch_code","branch_display","slbc_branch_no","delivery_channel_id","metro_type_id","tin","ifsc","micr","open_date","close_date","open_balance_date","clearing_house_gl_id","clearing_house_adj_gl_id","micr_city_id","region_id","mseb_region_id","ckyc_region_id","clearing_house_acccount_id","clearing_house_adj_acccount_id","ho_branch_adj_account_id","branch_ho_adj_account_id","schedule_id","ckyc_code","gl_opening_bal_date","gl_post_date","auto_interest_posting","auto_standing_posting","biomatric_device_no"] },
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Address",uid: "address",fastpath:"addresses"},
{label: "Branch Timings",uid: "branch_timings",fastpath:"branch_timings"},
{label:"Bulk",uid:"bulk"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Bank"}),
...controls.oc({ tab: "filter", c: "Bank", placeHolder: "Bank Code", name: "Branch-bank-bank_code",fastpath: "banks"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Branch-bank-bank_display"}),
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "branch_code",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description",description:'Starting partial search. e.g. You can search for Shivraj Deshmukh by typing shivraj.'}),
...controls.text({ tab: "filter",  placeHolder: "", name: "branch_display",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Delivery Channel"}),
...controls.oc({ tab: "filter", c: "DeliveryChannel", placeHolder: "Delivery Channel Code", name: "Branch-delivery_channel-delivery_channel_code",fastpath: "delivery_channels"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Branch-delivery_channel-delivery_channel_display"}),
...controls.displayText({ tab: "filter", label: "Metro Type"}),
...controls.oc({ tab: "filter", c: "MetroType", placeHolder: "Metro Type Code", name: "Branch-metro_type-metro_type_code",fastpath: "metro_types",autoopen:true}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Branch-metro_type-metro_type_display"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Bank",star:true}),
...controls.oc({ tab: "general", c: "Bank", placeHolder: "Bank Code", name: "bank_code",isRequired:true,fastpath: "banks" ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "bank_display"}),
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "branch_code",isRequired:true,maxlength:10}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "branch_display",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Slbc Branch No",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "slbc_branch_no",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Delivery Channel",star:false}),
...controls.oc({ tab: "general", c: "DeliveryChannel", placeHolder: "Delivery Channel Code", name: "delivery_channel_code",fastpath: "delivery_channels",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "delivery_channel_display"}),
...controls.displayText({ tab: "general", label: "Metro Type",star:false}),
...controls.oc({ tab: "general", c: "MetroType", placeHolder: "Metro Type Code", name: "metro_type_code",fastpath: "metro_types",autoopen:true,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "metro_type_display"}),
...controls.displayText({ tab: "general", label: "Tin",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "tin",maxlength:30}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Ifsc",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "ifsc",maxlength:30}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Micr",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "micr",maxlength:30}),
...controls.displayText({ tab: "general", label: ""}),
...controls.magicDateLabel({ tab: "general", label: "Open Date",target: "open_date",star:false}),
...controls.magicDate({ tab: "general", name: "open_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.magicDateLabel({ tab: "general", label: "Close Date",target: "close_date",star:false}),
...controls.magicDate({ tab: "general", name: "close_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.magicDateLabel({ tab: "general", label: "Open Balance Date",target: "open_balance_date",star:false}),
...controls.magicDate({ tab: "general", name: "open_balance_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Gl",star:false}),
...controls.oc({ tab: "general", c: "GL", placeHolder: "Gl Code", name: "gl_code",fastpath: "gls",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "gl_display"}),
...controls.displayText({ tab: "general", label: "Gl",star:false}),
...controls.oc({ tab: "general", c: "GL", placeHolder: "Gl Code", name: "gl_code",fastpath: "gls",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "gl_display"}),
...controls.displayText({ tab: "general", label: "Micr City Id",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "micr_city_id",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Region",star:false}),
...controls.oc({ tab: "general", c: "Region", placeHolder: "Region Code", name: "region_code",fastpath: "regions",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "region_display"}),
...controls.displayText({ tab: "general", label: "Region",star:false}),
...controls.oc({ tab: "general", c: "Region", placeHolder: "Region Code", name: "region_code",fastpath: "regions",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "region_display"}),
...controls.displayText({ tab: "general", label: "Region",star:false}),
...controls.oc({ tab: "general", c: "Region", placeHolder: "Region Code", name: "region_code",fastpath: "regions",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "region_display"}),
...controls.displayText({ tab: "general", label: "Account",star:false}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", name: "account_code",fastpath: "accounts",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display"}),
...controls.displayText({ tab: "general", label: "Account",star:false}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", name: "account_code",fastpath: "accounts",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display"}),
...controls.displayText({ tab: "general", label: "Account",star:false}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", name: "account_code",fastpath: "accounts",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display"}),
...controls.displayText({ tab: "general", label: "Account",star:false}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", name: "account_code",fastpath: "accounts",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display"}),
...controls.displayText({ tab: "general", label: "Schedule Id",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "schedule_id",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Code",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "ckyc_code",maxlength:14}),
...controls.displayText({ tab: "general", label: ""}),
...controls.magicDateLabel({ tab: "general", label: "Gl Opening Bal Date",target: "gl_opening_bal_date",star:false}),
...controls.magicDate({ tab: "general", name: "gl_opening_bal_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.magicDateLabel({ tab: "general", label: "Gl Post Date",target: "gl_post_date",star:false}),
...controls.magicDate({ tab: "general", name: "gl_post_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.checkBox({ tab: "general", label: "Auto Interest Posting",default:false, name: "auto_interest_posting" }),
...controls.checkBox({ tab: "general", label: "Auto Standing Posting",default:false, name: "auto_standing_posting" }),
...controls.displayText({ tab: "general", label: "Biomatric Device No",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "biomatric_device_no",maxlength:30}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "address", label: "Line 1",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.line_1",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "address", label: "Line 2",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.line_2",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "address", label: "Line 3",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.line_3",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "address", label: "Village",star:true}),
...controls.oc({ tab: "address", c: "Village", placeHolder: "Village Code", name: "address.village_code",isRequired:true,fastpath: "villages",hidden:false}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.village_display"}),
...controls.displayText({ tab: "address", label: "Taluka",star:true}),
...controls.oc({ tab: "address", c: "Taluka", placeHolder: "Taluka Code", name: "address.taluka_code",isRequired:true,fastpath: "talukas",hidden:false}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.taluka_display"}),
...controls.displayText({ tab: "address", label: "District",star:true}),
...controls.oc({ tab: "address", c: "District", placeHolder: "District Code", name: "address.district_code",isRequired:true,fastpath: "districts",hidden:false}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.district_display"}),
...controls.displayText({ tab: "address", label: "State",star:true}),
...controls.oc({ tab: "address", c: "State", placeHolder: "State Code", name: "address.state_code",isRequired:true,fastpath: "states",hidden:false}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.state_display"}),
...controls.displayText({ tab: "address", label: "Country",star:true}),
...controls.oc({ tab: "address", c: "Country", placeHolder: "Country Code", name: "address.country_code",isRequired:true,fastpath: "countries",hidden:false}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.country_display"}),
...controls.displayText({ tab: "address", label: "Pincode",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.pincode",maxlength:6}),
...controls.displayText({ tab: "address", label: ""}),
...controls.displayText({ tab: "address", label: "Latitude"}),
...controls.floatOnly({ tab: "address",  placeHolder: "", name: "address.latitude",maxlength:10}),
...controls.displayText({ tab: "address", label: ""}),
...controls.displayText({ tab: "address", label: "Longitude"}),
...controls.floatOnly({ tab: "address",  placeHolder: "", name: "address.longitude",maxlength:10}),
...controls.displayText({ tab: "address", label: ""}),
...controls.displayText({ tab: "address", label: "Short Name",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.short_name",maxlength:50}),
...controls.displayText({ tab: "address", label: ""}),
...controls.magicDateLabel({ tab: "branch_timings", label: "Start Time",target: "start_time",star:false}),
...controls.magicDate({ tab: "branch_timings", name: "start_time", dateType: "ontype" }),
...controls.displayText({ tab: "branch_timings", label: ""}),
...controls.magicDateLabel({ tab: "branch_timings", label: "End Time",target: "end_time",star:false}),
...controls.magicDate({ tab: "branch_timings", name: "end_time", dateType: "ontype" }),
...controls.displayText({ tab: "branch_timings", label: ""}),
...controls.displayText({ tab: "branch_timings", label: "Dow",star:false}),
...controls.numberOnly({ tab: "branch_timings",  placeHolder: "", name: "dow",maxlength:200}),
...controls.displayText({ tab: "branch_timings", label: ""}),

...controls.displayText({ tab:"branch_timings" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"branch_timings" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"branch_timings",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "branch_timings",
  requiredField: ["start_time","end_time","dow",],
required:[],
}, width: "col-sm-2"
}),
...controls.button({
tab:"branch_timings",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "branch_timings",
  requiredField: ["start_time","end_time","dow",]
}, width: "col-sm-2"
}),
{
  tab:"branch_timings",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Start Time", field: "start_time", displaytype: "date"},
    { label: "End Time", field: "end_time", displaytype: "date"},
    { label: "Dow", field: "dow"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "branch_timings"
},
]
,history:{
perPage: 10,
reportHeader: "Branches",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Bank",accessor: "Branch-bank-bank_display",},
{Header: "Branch Code",accessor: "branch_code",},
{Header: "Branch",accessor: "branch_display",},
{Header: "Branch Active",accessor: "branch_active",type:'tick'},
]}};
export default branches;